import React, {Component} from 'react';

import 'react-bootstrap';
import {connect} from "react-redux";
import { PagesForCaption, CaptionCodes } from '../../../config/Helper';

import ServiceBlock from './ServiceBlock';

class Service extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            
        }
    }

    componentWillMount() { 

    }

    componentDidMount() {
    }

    componentDidUpdate() {
        window.playVideo();  
        window.articleGallery();      
    }
  
    componentWillUnmount() {
        
    }
    
    
    componentWillReceiveProps(newProps) {
            
    }   
  
    render() {
        return (
            <div>
                <section className={`ftco-section destination_middle_srv ${parseInt(this.props.type_id, 10) % 2 === 0 ? 'bg-light' : ''}`}>
                    <div className="container">
                        <div className="row justify-content-center pb-5">
                            <div className="col-md-12 heading-section text-center ftco-animate">
                            <span className="subheading"></span>
                            {
                                this.props.type_key === null &&
                            <div>
                                <h2 className="mb-4">
                                    { this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf('destination_etc_service')] === undefined ? 
                                    "" :
                                    this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf('destination_etc_service')].title  }
                                </h2> 
                                <p>
                                    { this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf('destination_etc_service')] === undefined ? 
                                    "" :
                                    this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf('destination_etc_service')].description  }
                                </p>    
                            </div>
                            }
                            { this.props.type_key !== null &&
                            <div>
                                <h2 className="mb-4">
                                {this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf(CaptionCodes[PagesForCaption.indexOf('destination_detail')][this.props.type_key + 2 ])] === undefined ? 
                                "" :
                                this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf(CaptionCodes[PagesForCaption.indexOf('destination_detail')][this.props.type_key + 2 ])].title  }
                                </h2>
                                <p>
                                {this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf(CaptionCodes[PagesForCaption.indexOf('destination_detail')][this.props.type_key + 2 ])] === undefined ? 
                                "" :
                                this.props.captionTitle[CaptionCodes[PagesForCaption.indexOf('destination_detail')].indexOf(CaptionCodes[PagesForCaption.indexOf('destination_detail')][this.props.type_key + 2 ])].description  }
                                </p>
                            </div> 
                            }
                           
                           
                            
                            <p></p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ftco-animate" data-lightbox="gallery">
                                {
                                    this.props.services.map((service, key) => (
                                        
                                        <ServiceBlock
                                        key = {key}
                                        destinationID = {this.props.destinationID}
                                        id = {service.id}
                                        title = {service.title}
                                        type = {parseInt(this.props.type_id, 10)}
                                        image = {service.media_filename}
                                        media_type  = {service.media_filetype}
                                        />
                                    ))
                                }   
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}
export default connect(mapStateToProps)(Service);